module.exports = __webpack_public_path__ + "img/slide11-piece-36.c81656ea.png";